import React, { useReducer } from 'react'

export const BreadcrumbsContext = React.createContext();
export const BreadcrumbsDispatchContext = React.createContext();

export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS';

export const initialBreadcrumbsState = {
    breadcrumbsPath: []
}

function reducer(state, action){
    switch(action.type){
        case UPDATE_BREADCRUMBS: {
            return {
                breadcrumbsPath: [...state.breadcrumbsPath, action.payload]
            }
        }
        default:
            throw new Error('Bad Action Type - Breadcrumb Context')
    }
}

// eslint-disable-next-line react/prop-types
const BreadcrumbsContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialBreadcrumbsState);
    return (
      <BreadcrumbsDispatchContext.Provider value={dispatch}>
        <BreadcrumbsContext.Provider value={state}>{children}</BreadcrumbsContext.Provider>
      </BreadcrumbsDispatchContext.Provider>
    );
  };
  
  export default BreadcrumbsContextProvider;